import { render } from "./similar-products.vue?vue&type=template&id=1c05b098&scoped=true"
import script from "./similar-products.vue?vue&type=script&lang=js"
export * from "./similar-products.vue?vue&type=script&lang=js"

import "./similar-products.vue?vue&type=style&index=0&id=1c05b098&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c05b098"]])

export default __exports__